"use client";

import React from "react";
import { getFeatureFlags } from "@/lib/feature-flags";
import { ComingSoon } from "../coming-soon/coming-soon";

type FeatureFlagKeys = keyof ReturnType<typeof getFeatureFlags>;

interface FeatureGateProps {
  feature: FeatureFlagKeys;
  children: React.ReactNode;
  showComingSoon?: boolean;
}

/**
 * Feature flags are inlined `process.env.NEXT_PUBLIC_*` reads (see
 * `lib/feature-flags.ts`) — compile-time constants that cannot change at
 * runtime. They are therefore read directly here rather than through a React
 * context: the old `GlobalFeatureFlagsProvider` wrapped the entire app and
 * minted a new context value on every render for a value that never changes.
 */
function isFeatureEnabled(feature: FeatureFlagKeys): boolean {
  return getFeatureFlags()[feature] || false;
}

export function FeatureGate({ feature, children, showComingSoon = false }: FeatureGateProps) {
  if (isFeatureEnabled(feature)) {
    return <>{children}</>;
  }

  return showComingSoon ? <ComingSoon /> : null;
}
